export function routes($stateProvider) {
    $stateProvider
        .state('app.crm.empresas', {
        url: '/empresas',
        abstract: true
    })
        .state('app.crm.empresas.list', {
        url: '?{page:int}&{limit:int}&sortBy&filter',
        title: 'Clientes',
        template: '<crm-empresas-list-view></crm-empresas-list-view>',
        role: ['crmListarClientes'],
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.crm.empresas.details', {
        url: '/{id:int}',
        title: 'Detalhes do Cliente',
        template: '<crm-empresas-details-view></crm-empresas-details-view>',
        role: ['crmListarClientes'],
        params: {
            id: {
                dynamic: true
            }
        }
    })
        .state('app.crm.empresas.formEdit', {
        url: '/form/edit/{id:int}',
        title: 'Formulário do Cliente',
        template: '<crm-empresas-add-view></crm-empresas-add-view>',
        role: ['crmEditarDadosCliente'],
    })
        .state('app.crm.empresas.formCreate', {
        url: '/form/create',
        title: 'Formulário do Cliente',
        template: '<crm-empresas-add-view></crm-empresas-add-view>',
        // role: ['gasVerClientes'],
    });
}
routes.$inject = ['$stateProvider'];
